import PropTypes from 'prop-types';
import { List, ListItem, ListItemText, Typography } from '@mui/material';

const Info = ({ serviceData }) => {
	return (
		<>
			<Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
				Home visit booking
			</Typography>
			<Typography variant="h4" gutterBottom>
				{serviceData.service_name}
			</Typography>
			<List>
				<ListItem sx={{ py: 1, px: 0 }}>
					<Typography variant="body1">{serviceData.description}</Typography>
				</ListItem>
				<ListItem sx={{ py: 1, px: 0 }}>
					<ListItemText sx={{ mr: 2, fontWeight: 'bold' }} primary={'Test Price'} />
					<Typography variant="body1" sx={{ fontWeight: 'medium' }}>
						£{(serviceData.service_price / 100).toFixed(2)}
					</Typography>
				</ListItem>
			</List>
			{/* <Typography>
				Please note that the price above is the price for the test. Home visit may incur additional
				cost and charges
			</Typography> */}
		</>
	);
};

Info.propTypes = {
	serviceData: PropTypes.shape({
		service_id: PropTypes.string.isRequired,
		service_name: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		service_price: PropTypes.string.isRequired,
	}).isRequired,
	totalPrice: PropTypes.string.isRequired,
};

export default Info;
